import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerDownRight"><Path fillRule="evenodd" clipRule="evenodd" d="M5 4V14H17.5858L14.5858 11L16 9.58579L21.4142 15L16 20.4142L14.5858 19L17.5858 16H3V4H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerDownRight;
